import "./backgroundTimeline.css";
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import BackgroundMapTimeline from "./BackgroundMapTimeline";
import { useSatelightContext } from "../../provider/SatelightProvider";

interface TimelineElement {
  id: string;
  stimestamp: number;
  Interval: number;
  edtimestamp: number;
}

interface TimelineServiceProps {
  passSelectedTimeSlotValue: (value: string) => void;
  passSelectedDateSlotValue: (value: string) => void;
  From?: string;
  To?: string;
  passTimeIndexCount: (value: number) => void;
  selectModel: string;
  getValueFromLefSideMenu: string;
  openLayerTypeMap: Map<string, boolean>;
  passTimelineData: (data: TimelineElement[]) => void;
  getVoiceRecognitionValue: string;
}

export let ecmf3hStart:number;
export let ecmf3hEnd:number;
export let ecmf3hInterval:number;
export let ecmf6hStart:number;
export let ecmf6hEnd:number;
export let ecmf6hInterval:number;
export let icon1hStart:number;
export let icon1hEnd:number;
export let icon1hInterval:number;
export let icon3hStart:number;
export let icon3hEnd:number;
export let icon3hInterval:number;
export let layerStartDate:string;
export let layerIconStartDate:string;

const TimelineService: React.FC<TimelineServiceProps> = ({
  passSelectedTimeSlotValue,
  passSelectedDateSlotValue,
  From,
  To,
  passTimeIndexCount,
  selectModel,
  getValueFromLefSideMenu,
  openLayerTypeMap,
  passTimelineData,
  getVoiceRecognitionValue,
}) => {
  const [trueKeys, setTrueKeys] = useState<Set<string>>(new Set<string>());
  const [timelineDataArray, setTimelineDataArray] = useState<TimelineElement[]>(
    []
  );
  const [fetchedKeys, setFetchedKeys] = useState<Set<string>>(new Set<string>());
  const [isTimelineDataLoaded, setIsTimelineDataLoaded] = useState<boolean>(false); 
  const [isSatelightClick, setIsSatelightClick] = useState<string>("satelliteNotClick"); 
  const { satelliteTime } = useSatelightContext();
  const [ecmf3h, setEcmf3h] = useState<{ start?: number, end?: number }>({});
  const [ecmf6h, setEcmf6h] = useState<{ start?: number, end?: number }>({});
 
  useEffect(() => {
 
    const updatedTrueKeys = new Set<string>();
    setTimelineDataArray([]);
    const newFetchedKeys = new Set<string>(fetchedKeys); 

    // Add only the keys with value true from openLayerTypeMap
    openLayerTypeMap.forEach((value, key) => {
      if (value === true) {

        if (
          key === "wind" ||
          key === "temperature" ||
          key === "airPressure" ||
          key === "rain" || 
          key === "tides" || 
          key === "rainProbability" || 
          key === "AtmosphericRivers"||
          key === "Tonardo" ||
          key === "Cyclones" || 
          key === "Droughts" ||
          key === "JetStreams" ||
          key === "StormSurges" ||
          key === "DustStorms"
        ) {
          if (selectModel === "ECMWF") {
            updatedTrueKeys.add("ecmwfst_3h");
            updatedTrueKeys.add("ecmwfst_6h");
            updatedTrueKeys.delete("glofas_1d");
            updatedTrueKeys.delete("iconfst_1h");
            updatedTrueKeys.delete("iconfst_3h");
          } else if (selectModel === "ICON") {
            updatedTrueKeys.add("iconfst_1h");
            updatedTrueKeys.add("iconfst_3h");
            updatedTrueKeys.delete("ecmwfst_3h");
            updatedTrueKeys.delete("ecmwfst_6h");
            updatedTrueKeys.delete("glofas_1d");
          }
        } else if (key === "flood") {
          updatedTrueKeys.add("glofas_1d");
          updatedTrueKeys.delete("ecmwfst_3h");
          updatedTrueKeys.delete("ecmwfst_6h");
          updatedTrueKeys.delete("iconfst_1h");
          updatedTrueKeys.delete("iconfst_3h");
        }else if (key === "satellite") {
          setIsSatelightClick("satelliteClick")
          setIsTimelineDataLoaded(true);
          updatedTrueKeys.delete("glofas_1d");
          updatedTrueKeys.delete("ecmwfst_3h");
          updatedTrueKeys.delete("ecmwfst_6h");
          updatedTrueKeys.delete("iconfst_1h");
          updatedTrueKeys.delete("iconfst_3h");
        } 
         else if (key === "river") {
          updatedTrueKeys.add(key);
        } else if (key === "earlywarning") {
          updatedTrueKeys.add("ews");
        } else if (key === "hzIncidents") {
          updatedTrueKeys.add("incd");
        } else if(key === "pressure"){
          if (selectModel === "ECMWF") {
            updatedTrueKeys.add("ecmwfst_3h");
            updatedTrueKeys.add("ecmwfst_6h");
            updatedTrueKeys.delete("glofas_1d");
            updatedTrueKeys.delete("iconfst_1h");
            updatedTrueKeys.delete("iconfst_3h");
          } else if (selectModel === "ICON") {
            updatedTrueKeys.add("iconfst_1h");
            updatedTrueKeys.add("iconfst_3h");
            updatedTrueKeys.delete("ecmwfst_3h");
            updatedTrueKeys.delete("ecmwfst_6h");
            updatedTrueKeys.delete("glofas_1d");
          }
        }
        // else if (
        //   !["wind", "temperature", "airPressure", "rain"].includes(key)
        // ) {
        //   console.log("--------------------here----------------",updatedTrueKeys);
        //   updatedTrueKeys.delete("ecmwfst_3h");
        //   updatedTrueKeys.delete("ecmwfst_6h");
        //   updatedTrueKeys.delete("glofas_1d");
        //   updatedTrueKeys.delete("icon_1h");
        // }
      }else{
        if (key === "satellite"){
          setIsSatelightClick("notClick")
        } 
      }
    });
  
    setTrueKeys(updatedTrueKeys);

     const fetchAllData = async () => {
      // Reset the flag before starting the data fetch process
      setIsTimelineDataLoaded(false);
      const fetchPromises = Array.from(updatedTrueKeys).map((key) => fetchTimelineData(key as string));
      await Promise.all(fetchPromises);  // Wait until all fetch requests are complete

      // Set the flag to true once all data has been fetched and processed
      setIsTimelineDataLoaded(true);
    };

    fetchAllData();


  }, [openLayerTypeMap, getValueFromLefSideMenu, selectModel]);

  const fetchTimelineData = async (type: string) => {
   
    try {
      const response = await axios.get(
        `https://mobile.mobilise-project.org.uk/mobisense/getTimeLineMetaData?layername=${type}`
      );
      const timelineData = response.data;
      // Check if timelineData is an array, if it's an object, wrap it in an array
      const dataArray = Array.isArray(timelineData)
        ? timelineData
        : [timelineData];

      // Filter out any empty or falsy elements
      const validDataArray = dataArray.filter((item) => item); // Removes any falsy values (e.g., empty strings, null, undefined)

      // Deduplicate the incoming data based on ID
      const uniqueDataArray = validDataArray.filter(
        (item, index, self) => index === self.findIndex((t) => t.id === item.id)
      );

      // Set the unique data to the timelineDataArray state
      setTimelineDataArray((prevData) => {
        // Combine previous data with new unique data and filter duplicates
        const combinedData = [...prevData, ...uniqueDataArray];
        return combinedData.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.id === item.id)
        );
      });
      getTimeLineValues(timelineData);
    } catch (error) {
      console.error("Error fetching timeline data", error);
    }
  };

  const getTimeLineValues = (timeData: any) => {
    // Ensure timeData is an array; if not, wrap it in an array
    const dataArray = Array.isArray(timeData) ? timeData : [timeData];
  
    dataArray.forEach((item) => {
      // Check if the item corresponds to ecmf3h or ecmf6h based on the `id`
      if (item.id === "ecmwfst_3h") {
        ecmf3hStart = item.stimestamp;
        ecmf3hEnd = item.edtimestamp;
        // ecmf3hStart = 1731715200;
        // ecmf3hEnd = 1732233600;
       ecmf3hInterval=item.Interval;
       const milliseconds = ecmf3hStart * 1000; // Convert to full milliseconds (since Date expects it in full ms)

       // Create a Date object
       const date = new Date(milliseconds);
     
       // Format the date
       layerStartDate = date.toISOString().slice(0, 10); 
      } else if (item.id === "ecmwf6h") {
        ecmf6hStart = item.stimestamp;
        ecmf6hEnd = item.edtimestamp;
        // ecmf6hStart = 1732233600;
        // ecmf6hEnd = 1732752000;
        ecmf6hInterval=item.Interval;
      }else if (item.id === "iconfst_1h") {
        icon1hStart = item.stimestamp;
        icon1hEnd = item.edtimestamp;
        icon1hInterval=item.Interval;
        const milliseconds = icon1hStart * 1000; // Convert to full milliseconds (since Date expects it in full ms)

        // Create a Date object
        const date = new Date(milliseconds);
      
        // Format the date
        layerIconStartDate = date.toISOString().slice(0, 10); 
      }else if (item.id === "iconfst_3h") {
        icon3hStart = item.stimestamp;
        icon3hEnd = item.edtimestamp;
        icon3hInterval=item.Interval;


      }
    });

  };
  

  useEffect(() => {
  //  console.log("Combined timeline data:", timelineDataArray);
    passTimelineData(timelineDataArray);
  }, [timelineDataArray, passTimelineData]);

  useEffect(() => {}, [trueKeys]);
  useEffect(() => {
  }, [isSatelightClick]);

  useEffect(() => {}, [satelliteTime.entries]);
  

const layerTLMeta: TimelineElement[] = [
  {
    "edtimestamp": 1732233600,
    "stimestamp": 1731715200,
    "id": "ecmwfst_3h",
    "Interval": 10800
},
{
  "edtimestamp": 1732752000,
  "stimestamp": 1732233600,
  "id": "ecmwf6h",
  "Interval": 21600
}
];

  return (
    <div>
      {isTimelineDataLoaded &&((timelineDataArray.length !== 0) ||(satelliteTime.length>0))   && (
        <BackgroundMapTimeline
          passSelectedDateSlotValue={passSelectedDateSlotValue}
          passSelectedTimeSlotValue={passSelectedTimeSlotValue}
          timelineDataArray={timelineDataArray}
          getVoiceRecognitionValue={getVoiceRecognitionValue}
          isSatelightClick={isSatelightClick}
          satelliteTime={satelliteTime}
        />
      )}
    </div>
  );
};

export default TimelineService;
